import React from 'react';

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height
	};
}

export function useWindowDimensions() {
	const [windowDimensions, setWindowDimensions] = React.useState(getWindowDimensions());

	React.useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowDimensions;
}

export const useCurrentWidth = () => {
	const { width } = useWindowDimensions();
	return {
		mobileWidth: width < 850
	};
};

export const useIsHorizontalScreen = () => {
	return window.innerWidth / window.innerHeight < 1;
};

export function useIsMobileCheck({ number = 850 }: { number?: number } = {}) {
	const [isMobile, setIsMobile] = React.useState(window.matchMedia(`(max-width: ${number}px)`).matches);

	React.useEffect(() => {
		const mediaQuery = window.matchMedia(`(max-width: ${number}px)`);
		const changeHandler = (e: { matches: boolean | ((prevState: boolean) => boolean) }) => {
			setIsMobile(e.matches);
		};

		// Debido a error de compatibilidad en ciertos versiones de safaris y chrome, previos a v54  chrome y v14 safari
		try {
			mediaQuery.addEventListener('change', changeHandler);
		} catch {
			mediaQuery.addListener(changeHandler);
		}
		return () => {
			try {
				mediaQuery.removeEventListener('change', changeHandler);
			} catch (e) {
				mediaQuery.removeListener(changeHandler);
			}
		};

		// mediaQuery.addEventListener('change', changeHandler);
		// return () => mediaQuery.removeEventListener('change', changeHandler);
	}, []);

	return isMobile;
}
